<template>
  <div class="name-wrapper">
    <div class="name" v-if="initdata.title">{{initdata.title}}</div>
    <div class="name-search">
      <input class="search-input" v-model="searchValue" @keyup.enter="search" placeholder="请输入...">
      <div class="iconfont icon-sousuo sousuo" @click="search"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["initdata", "filterListIndex"],
  data() {
    return {
      searchValue: ""
    };
  },
  methods: {
    search() {
      this.$emit("event", {
        fn: "search",
        params: {
          searchValue: this.searchValue,
          filterListIndex: this.filterListIndex
        }
      });
    },
    reset(){
      this.searchValue = ''
      this.$emit("event", {
        fn: "reset",
      })
    }
  },
  components: {}
};
</script>

<style scoped>
.name-wrapper {
  padding: 20px 16px;
}
.name {
  padding-bottom: 20px;
  color: #4b4b4b;
  font-size: 16px;
}
.name-search {
  display: flex;
  align-items: center;
  height: 35px;
  border-radius: 4px;
  border: 1px solid #c7c7c7;
  background: #f1f1f1;
}
.search-input {
  flex: 1;
  font-size: 14px;
  padding-left: 10px;
  color: #666;
  background: transparent;
}
.sousuo {
  color: #9a9a9a;
  font-size: 16px;
  padding-right: 16px;
  padding-left: 10px;
  cursor: pointer;
}
</style>
